import { render, staticRenderFns } from "./DialogQrcodePolicyDetail.vue?vue&type=template&id=4bc2fb9c&"
import script from "./DialogQrcodePolicyDetail.vue?vue&type=script&lang=js&"
export * from "./DialogQrcodePolicyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports